document.addEventListener('DOMContentLoaded', function () {
   const products = document.querySelectorAll('.tp-main-d5');
   
   products.forEach((product) => {
     const quantityBox = product.querySelector('.quantity-box-d5');
     const quantityInput = quantityBox.querySelector('.quantity-input-d5');
     const minusButton = quantityBox.querySelector('.qty-minus-d5');
     const plusButton = quantityBox.querySelector('.qty-plus-d5');
     const atcBtn = product.querySelector('.d5-travel-pack-atc');

     // Decrease quantity
     minusButton.addEventListener('click', (e) => {
       e.preventDefault();
       const currentValue = parseInt(quantityInput.value, 10);
       if (currentValue > parseInt(quantityInput.min, 10)) {
         quantityInput.value = currentValue - 1;
       }
       // Set data-quantity attribute on the button
       atcBtn.setAttribute('data-quantity', quantityInput.value);
     });

     // Increase quantity
     plusButton.addEventListener('click', () => {
       const currentValue = parseInt(quantityInput.value, 10);
       quantityInput.value = currentValue + 1;
       // Set data-quantity attribute on the button
       atcBtn.setAttribute('data-quantity', quantityInput.value);
     });

     // Handle manual input change
     quantityInput.addEventListener('input', () => {
       // Set data-quantity attribute on the button
       atcBtn.setAttribute('data-quantity', quantityInput.value);
     });

     // Trigger event when the 'Add to Cart' button is clicked
     atcBtn.addEventListener('click', (event) => {
       window.onButtonClickD5(event);
     });
   });
});
